import { Checkbox, DatePicker, DefaultButton, DetailsList, FontWeights, IButtonStyles, IconButton, IIconProps, Label, mergeStyleSets, MessageBar, Modal, Pivot, PivotItem, Position, PrimaryButton, ProgressIndicator, SpinButton, Stack, TextField, useTheme } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import * as React from 'react';
import { IEventSchedule } from '../../../../../Models/Event/IEventSchedule';
import { ISchedulesAttendeeList } from '../../../../../Models/Event/ISchedulesAttendeeList';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';
import { AttendeeList } from '../AttendeeList/AttendeeList';
import { AttendeeListView } from '../AttendeeList/AttendeeListView';
import TeachersList from '../TeachersList/TeachersList';

interface IEventScheduleDetailViewProps {
    eventSchedule?:IEventSchedule;
    isLoading: boolean;
    isOpened: boolean;
    onDismiss: () => void;
    propertyChanged: (key: string, value: any) => void;
    statusMessage?: IStatusMessage;
    refresh: () => void;
  
}


export const EventScheduleDetailView: React.FunctionComponent<IEventScheduleDetailViewProps> = (props) => {
    const titleId = useId('title');
    const theme = useTheme();


    const cancelIcon: IIconProps = { iconName: 'Cancel' };
    const contentStyles = mergeStyleSets({
        container: {
            display: 'flex',
            flexFlow: 'column nowrap',
            alignItems: 'stretch',
        },
        header: [
            theme.fonts.xLargePlus,
            {
                flex: '1 1 auto',
                borderTop: `4px solid ${theme.palette.themePrimary}`,
                color: theme.palette.neutralPrimary,
                display: 'flex',
                alignItems: 'center',
                fontWeight: FontWeights.semibold,
                padding: '12px 12px 14px 24px',
            },
        ],
        body: {
            flex: '4 4 auto',
            padding: '0 24px 24px 24px',
            overflowY: 'hidden',
            selectors: {
                p: { margin: '14px 0' },
                'p:first-child': { marginTop: 0 },
                'p:last-child': { marginBottom: 0 },
            },
        },
    });
    const iconButtonStyles: Partial<IButtonStyles> = {
        root: {
            color: theme.palette.neutralPrimary,
            marginLeft: 'auto',
            marginTop: '4px',
            marginRight: '2px',
        },
        rootHovered: {
            color: theme.palette.neutralDark,
        },
    };


    return (<Stack>
        <Stack styles={{ root: { height: 10 } }}>
            {props.isLoading ? <ProgressIndicator /> : null}
        </Stack>
             <Stack tokens={{ childrenGap: 5 }}>
            <Stack verticalAlign="end" tokens={{ childrenGap: 5 }}>
                <TextField label="Datum lekce" readOnly value={props.eventSchedule?.date.toLocaleDateString("cs-CZ")} styles={{ root: { minWidth: 200 } }} />
                <TextField label="Popis činnosti" multiline readOnly value={props.eventSchedule?.description} styles={{ root: { minWidth: 200 } }} />                     
            </Stack>
            <Pivot aria-label="Basic Pivot Example">
                <PivotItem headerText="Docházka žáků">
                    <AttendeeList refresh={props.refresh} eventSchedule={props.eventSchedule} />
                </PivotItem>
                <PivotItem headerText="Docházka lektorů">
                    <TeachersList refresh={props.refresh} eventSchedule={props.eventSchedule} />
                </PivotItem>                
            </Pivot>
            
                {props.statusMessage ? <MessageBar messageBarType={props.statusMessage.type}>{props.statusMessage.message}</MessageBar> : null}
            </Stack>
         
        <Stack horizontal tokens={{ padding: 20, childrenGap: 15 }} horizontalAlign="center">
             
            <DefaultButton onClick={props.onDismiss}>Zavřít</DefaultButton>
        </Stack>
    </Stack>)
}
